import { jwtDecode } from "jwt-decode";
import { IUserTokenDataDto } from "../../../interfaces/user/IUserTokenDataDto";

export function extractToken(token: string) {
    const decodeToken: IUserTokenDataDto = jwtDecode(token);

    return decodeToken;
}